import { BaseDataModel } from "./base";

export type DealType = "Grid" | "Zone" | "ModGrid";

export class Deal extends BaseDataModel {
	name!: string;
	density!: number;
	testPackage!: string;
	depth!: number;
	frequencyOfMicros?: number;
	type!: DealType;
	season!: string;
	syncMethod?:
		| "Event ID"
		| "Grower-Field-Sample"
		| "Event ID Immut"
		| "Lab ID"
		| "Lab ID Immut"
		| "Field ID + GPS"
		| "GPS Only";
	syncMethod2?: "Lab ID" | "None";
	labAccountNumber!: string;
	specialTag?:
		| "Scan Only"
		| "Strip"
		| "Manual"
		| "SCOUT - 1"
		| "SCOUT - 2"
		| "SCOUT - 3"
		| "SCOUT - 4"
		| "BD"
		| "BD Scan Only"
		| "BD Waters"
		| "Loam BD Large Plot"
		| "Loam BD Small Plot"
		| "Lab Analysis Estimate"
		| "Loam Std Small Plot";
	testCompanyName?: string;
	customizer?: string;
	labName!: string;
	isActive!: boolean;
	isConfigOnly!: boolean;
	isComposite!: boolean;
	isMultiComposite!: boolean;
	isPtsRequired!: boolean;
	companyId!: string;
	fieldParameters: string[] = [];
	samplingTypeSpecial?: string;
}
